import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-54c9bf76"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "md:tw-flex tw-justify-between container-trend-banner tw-px-15px md:tw-px-[50px] tw-py-25px"
};
var _hoisted_2 = {
  "class": "md:tw-flex tw-flex-col"
};
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = ["innerHTML"];
var _hoisted_5 = {
  id: "trend-input",
  "class": "tw-relative"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = ["src", "onClick"];
var _hoisted_8 = {
  "class": "tw-relative"
};
var _hoisted_9 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_base_autocomplete = _resolveComponent("base-autocomplete");
  var _component_base_button = _resolveComponent("base-button");
  return _openBlock(), _createElementBlock("div", {
    "class": _normalizeClass([!_ctx.isMobile ? 'tw-container-xl tw-mx-auto tw-px-15px sm:tw-px-20px' : '', _ctx.customContainerClasses]),
    style: _normalizeStyle(_ctx.customContainerStyles)
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", {
    "class": "tw-text-18 sm:tw-text-22 tw-font-semibold tw-m-0 tw-mb-15px md:tw-mb-5px",
    innerHTML: _ctx.wkLabels.trendCtaQuoteValuation
  }, null, 8 /* PROPS */, _hoisted_3), _createElementVNode("p", {
    "class": "tw-text-16 tw-hidden md:tw-block",
    innerHTML: _ctx.wkLabels.searchCityOrZone
  }, null, 8 /* PROPS */, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createVNode(_component_base_autocomplete, {
    id: "header_autocomplete_places",
    modelValue: _ctx.place,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.place = $event;
    }),
    placeholder: _ctx.wkLabels.enterAddress,
    theme: "all-bordered",
    "on-input-change-cb": _ctx.callbackFn
  }, {
    lefticon: _withCtx(function () {
      return [_createElementVNode("img", {
        src: "".concat(_ctx.cdn, "/_ui/img/Ico/pin_outlined.svg"),
        alt: "cerca",
        "class": "text-input-icon left md"
      }, null, 8 /* PROPS */, _hoisted_6)];
    }),
    righticon: _withCtx(function (_ref) {
      var handleClean = _ref.handleClean;
      return [_ctx.place && _ctx.place.label.length > 0 ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: "".concat(_ctx.cdn, "/_ui/img/Ico/close.svg"),
        "class": "text-input-icon right sm",
        alt: "Clean Icon",
        style: {
          "right": "40px"
        },
        onClick: _withModifiers(function ($event) {
          handleClean();
          _ctx.place = undefined;
        }, ["stop"])
      }, null, 8 /* PROPS */, _hoisted_7)) : _createCommentVNode("v-if", true)];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "placeholder", "on-input-change-cb"]), _createVNode(_component_base_button, {
    "class": "tw-p-0 tw-rounded-circle tw-absolute btn-trend",
    "btn-class": "tw-btn-w-primary",
    "icon-name": "search-white.svg",
    "icon-class": "tw-mr-0",
    "is-loading": _ctx.loading,
    onClick: _withModifiers(_ctx.searchTrend, ["stop"])
  }, null, 8 /* PROPS */, ["is-loading", "onClick"])])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: "".concat(_ctx.cdn, "/_ui/img/Ico/nerd-mercato-home.svg"),
    alt: "immagine nerd valuta",
    "class": "tw-mr-5px tw-h-auto tw-absolute img-trend"
  }, null, 8 /* PROPS */, _hoisted_9)])])], 6 /* CLASS, STYLE */);
}